import { __assign } from '../../../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import styles from './Icon.module.scss.js';

var Icon = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, _c = _a.size, size = _c === void 0 ? 'm' : _c, _d = _a.position, position = _d === void 0 ? 'right' : _d;
    return (jsx("div", __assign({ className: clsx(styles.icon, (_b = {},
            _b[styles.iconLeft] = position === 'left',
            _b[styles.iconRight] = position === 'right',
            _b[styles.iconMedium] = size === 'm',
            _b[styles.iconLarge] = size === 'l',
            _b), className) }, { children: children })));
};

export { Icon };
